document.addEventListener('DOMContentLoaded', function() {
    // Schritt 1: Maximale kumulierte Höhe aller <p>-Tags in den .block-rte-Elementen berechnen
    const blockRteElements = document.querySelectorAll('#template--29496418763135__multicolumn_ikrDCr .blocks-rte,#template--29496418599295__multicolumn_Vp9BNH .blocks-rte,#template--29776648733055__multicolumn_zFnqGU .blocks-rte');
    let maxCumulativePHeight = 0;


    blockRteElements.forEach(function(blockRte) {
        const pTags = blockRte.querySelectorAll('p');
        let cumulativePHeight = 0;

        pTags.forEach(function(pTag) {
            const style = window.getComputedStyle(pTag);
            const height = pTag.offsetHeight;
            const marginTop = parseFloat(style.marginTop) || 0;
            const marginBottom = parseFloat(style.marginBottom) || 0;
            cumulativePHeight += height + marginTop + marginBottom;
        });

        if (cumulativePHeight > maxCumulativePHeight) {
            maxCumulativePHeight = cumulativePHeight;
        }
    });


    // Schritt 2: Für jedes .block-rte-Element die Differenz berechnen und ein <div> einfügen
    blockRteElements.forEach(function(blockRte) {
        const pTags = blockRte.querySelectorAll('p');
        let cumulativePHeight = 0;

        pTags.forEach(function(pTag) {
            const style = window.getComputedStyle(pTag);
            const height = pTag.offsetHeight;
            const marginTop = parseFloat(style.marginTop) || 0;
            const marginBottom = parseFloat(style.marginBottom) || 0;
            cumulativePHeight += height + marginTop + marginBottom;
        });

        const subtractedHeight = maxCumulativePHeight - cumulativePHeight || 1;
        if (pTags.length > 0) {
            const lastPTag = pTags[pTags.length - 1];
            const div = document.createElement('div');
            div.className = 'gap';
            div.style.height = subtractedHeight + 'px';
            div.style.marginBottom = '0';
            lastPTag.insertAdjacentElement('afterend', div);
        }
    });
});